import { useState } from "react";
import { MONTHS } from "../lib/brand";

function Bars({ months, peak = [], type }) {
  const color = type === "indian" ? "bg-harvest" : "bg-terracotta";
  return (
    <div className="grid grid-cols-12 gap-[3px]">
      {MONTHS.map((_, i) => {
        const active = months.includes(i + 1);
        const isPeak = peak.includes(i + 1);
        return (
          <span
            key={i}
            className={`relative flex h-3 items-center justify-center rounded-[1px] transition-colors duration-300 ${
              active ? color : "bg-unconfirmed/60"
            }`}
          >
            {isPeak && <span className="h-1 w-1 rounded-full bg-cream-100 ring-1 ring-gold" />}
          </span>
        );
      })}
    </div>
  );
}

function Group({ label, count, rows, type, highlight }) {
  const [hover, setHover] = useState(null);
  if (!rows.length) return null;
  return (
    <div className="mb-10">
      <div className="mb-4 flex items-center gap-3">
        <span className={`h-2.5 w-2.5 rounded-full ${type === "indian" ? "bg-harvest" : "bg-terracotta"}`} />
        <span className="font-sans text-sm font-medium text-forest">
          {label} — {count} {count === 1 ? "variety" : "varieties"}
        </span>
      </div>

      {/* month header */}
      <div className="mb-2 hidden grid-cols-[minmax(150px,1.1fr)_2.6fr] gap-6 md:grid">
        <span />
        <div className="grid grid-cols-12 gap-[3px]">
          {MONTHS.map((m) => (
            <span key={m} className="text-center font-mono text-[0.6rem] uppercase tracking-wider text-forest-muted">
              {m[0]}
            </span>
          ))}
        </div>
      </div>

      <div className="divide-y divide-border/70 border-y border-border/70">
        {rows.map((v, idx) => {
          const isHit = highlight && `${v.name}__${v.region}` === highlight;
          return (
            <div
              key={`${v.name}-${idx}`}
              data-testid={`variety-row-${type}-${idx}`}
              data-hit={isHit ? "true" : undefined}
              onMouseEnter={() => setHover(idx)}
              onMouseLeave={() => setHover(null)}
              className={`grid grid-cols-1 gap-3 rounded-sm py-3.5 transition-opacity duration-300 md:grid-cols-[minmax(150px,1.1fr)_2.6fr] md:items-center md:gap-6 ${
                isHit ? "bg-gold/15 px-3 opacity-100 ring-1 ring-gold" : hover !== null && hover !== idx ? "opacity-40" : "opacity-100"
              }`}
            >
              <div className="min-w-0">
                <div className="truncate font-display text-lg leading-tight text-forest">{v.name}</div>
                <div className="truncate font-mono text-[0.68rem] uppercase tracking-wide text-forest-muted">
                  {v.region}
                </div>
              </div>
              <Bars months={v.months} peak={v.peak_months} type={type} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function SeasonTimeline({ family, highlight }) {
  if (!family) return null;
  const indian = family.varieties.filter((v) => v.origin_type === "indian");
  const imported = family.varieties.filter((v) => v.origin_type === "imported");

  return (
    <div data-testid="season-timeline" className="min-w-[520px] md:min-w-0">
      <Group label="Indian harvest & market window" count={indian.length} rows={indian} type="indian" highlight={highlight} />
      <Group label="Imported market window" count={imported.length} rows={imported} type="imported" highlight={highlight} />
    </div>
  );
}
